import {useState, useEffect} from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from "three"

const keys = { ArrowUp: "forward", ArrowDown: "backward", ArrowLeft: "left", ArrowRight: "right", KeyA : "left", KeyD : "right", KeyW : "up", KeyS : "down"}
const moveFieldByKey = (key) => keys[key]
const euler = new THREE.Euler(0, 0, 0, "YXZ")
const minPolarAngle = 0;
const maxPolarAngle = Math.PI;
const _PI_2 = Math.PI/2;
let moving = false

const usePlayerControls = () => {
    const [movement, setMovement] = useState({ forward: false, backward: false, left: false, right: false, up : false, down : false})
  
    const {camera} = useThree()
    // const propogation = useStore(state => state.propogateToStall)
    // const setPan = useStore(state => state.pan.setPan)
    
    const handleMouseMove = (e) => {
    //  if(propogation.exitButton === false){
        if(e.buttons === 1){
        const movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
        const movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;
  
        euler.setFromQuaternion( camera.quaternion );
  
              euler.y -= movementX * 0.002;
              euler.x -= movementY * 0.002;
  
              euler.x = Math.max( _PI_2 - maxPolarAngle, Math.min( _PI_2 - minPolarAngle, euler.x ) );
  
              camera.quaternion.setFromEuler( euler );
        // setPan(true)
      } else{
        // setPan(false)
      }
    //  }
    }
   
    useEffect(() => {
      const handleKeyDown = (e) => setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: true }))
      const handleKeyUp = (e) => setMovement((m) => ({ ...m, [moveFieldByKey(e.code)]: false }))
      document.addEventListener("keydown", handleKeyDown)
      document.addEventListener("keyup", handleKeyUp)
      document.addEventListener("pointermove", handleMouseMove)
  
      return () => {
        document.removeEventListener("keydown", handleKeyDown)
        document.removeEventListener("keyup", handleKeyUp)
        document.removeEventListener("pointermove", handleMouseMove)
      }
    }, [])
    return movement
  }

export default usePlayerControls